import cn from "classnames";

import type { Ad as AdType } from "../../types/ads/adResource";
import type { CardsResponse } from "../../types/content";
import type { FeedItems } from "../../types/content/feedItem";
import type { ListView } from "../../types/webTypes";

import { StickySideAd } from "../Ad/StickySideAd/StickySideAd";
import { Cards } from "../Cards/Cards";
import styles from "./Feed.module.scss";
import { LatestNewsLayout } from "./LatestNewsLayout/LatestNewsLayout";
import { ListLayout } from "./ListLayout/ListLayout";
import { TopNewsLayout } from "./TopNewsLayout/TopNewsLayout";

const Feed = ({
  data,
  wideScreenSideAd,
  wideScreenSideAd2,
  sponsoredBannerAdResource,
  isFirstFeed,
  layoutType,
  listView,
  endOfFeed,
  headerTitle,
  isLoggedIn = false,
  cards,
}: {
  data: FeedItems;
  cards?: CardsResponse;
  isLoggedIn?: boolean;
  wideScreenSideAd?: AdType;
  wideScreenSideAd2?: AdType;
  sponsoredBannerAdResource?: AdType;
  isFirstFeed?: boolean;
  layoutType: "top" | "latest" | "list";
  listView?: ListView;
  endOfFeed?: boolean;
  headerTitle?: string;
}) => {
  const hasFeedData = !!data?.length;

  const cardsIsAllowedToRender = isFirstFeed && cards && layoutType === "top";

  return (
    <div
      className={cn([
        styles.feedContainer,
        wideScreenSideAd && styles.withWidescreenAd,
        isFirstFeed && styles.firstFeed,
      ])}
    >
      <div className={cn([styles.feed, endOfFeed && styles.endOfFeed])}>
        {cardsIsAllowedToRender && <Cards cards={cards} />}
        {layoutType === "top" && (
          <TopNewsLayout
            isLoggedIn={isLoggedIn}
            data={data}
            isFirstFeed={isFirstFeed}
          />
        )}
        {layoutType === "latest" && (
          <LatestNewsLayout
            isLoggedIn={isLoggedIn}
            data={data}
            isFirstFeed={isFirstFeed}
          />
        )}

        {layoutType === "list" && (
          <ListLayout
            listView={listView!}
            isFirstFeed={isFirstFeed}
            data={data}
            sponsoredBannerAdResource={sponsoredBannerAdResource}
            endOfFeed={endOfFeed}
            headerTitle={headerTitle}
          />
        )}
      </div>
      {hasFeedData &&
        (isFirstFeed ? (
          <StickySideAd adResource={wideScreenSideAd} hasBottomGradientStyle />
        ) : (
          <StickySideAd
            adResource={wideScreenSideAd2}
            hasBottomGradientStyle={false}
          />
        ))}
    </div>
  );
};

export { Feed };
